import React from 'react';
import { BarChart3, HeartPulse } from 'lucide-react';

// Matches finance/moduleComponents/NavbarMiddle.jsx: fixed pill below NavbarTop,
// rendered by health_main.js (the L2 parent) — not by the tab component itself.
// L1: Areas = specialties (HeartPulse = health cue); Stats = charts.
const SUBTABS = [
  { id: 'areas', label: 'Areas', Icon: HeartPulse },
  { id: 'stats', label: 'Stats', Icon: BarChart3 },
];

const NavbarMiddle = ({ activeTabL1, setActiveTabL1 }) => {
  return (
    <div className="w-full flex justify-center fixed top-16 left-0 z-10 pb-2">
      <div className="bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm inline-flex gap-4">
        {SUBTABS.map(({ id, label, Icon }) => (
          <button
            key={id}
            onClick={() => setActiveTabL1(id)}
            className={`flex items-center gap-2 text-xs px-4 py-1.5 rounded-full transition-colors ${
              activeTabL1 === id
                ? 'bg-module-health text-white'
                : 'hover:bg-gray-100 text-gray-700'
            }`}
          >
            <Icon className="h-4 w-4" strokeWidth={2} />
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavbarMiddle;
